import React from "react";

type SwitchProps = {
  disabled?: boolean;
  checked?: boolean | null;
  onChange?: (checked: boolean) => void;
  size?: "small" | "default" | "stupid";
};

export const Switch = ({
  disabled = false,
  checked = false,
  onChange = () => {},
  size = "default",
}: SwitchProps) => {
  const isChecked = checked === null ? false : checked;

  // Size variants
  const sizes = {
    small: {
      container: "w-7 h-4",
      circle: "w-3 h-3",
      translate: "translate-x-3.5",
    },
    default: {
      container: "w-9 h-5",
      circle: "w-4 h-4",
      translate: "translate-x-4.5",
    },
    stupid: {
      container: "w-500 h-64",
      circle: "w-56 h-56",
      translate: "translate-x-64",
    },
  };

  const currentSize = sizes[size];

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => !disabled && onChange(!isChecked)}
      className={`
        ${currentSize.container}
        relative inline-flex items-center tra
        rounded-full
        transition-colors duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-neutral-400 
        ${isChecked ? "bg-neutral-900" : "bg-gray-300"}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
      `}
      role="switch"
      aria-checked={isChecked}
    >
      <span
        style={{
          marginBottom: "0px",
        }}
        className={`
          ${currentSize.circle}
          inline-block
          bg-white
          rounded-full
          shadow-lg
          transform transition-transform duration-200 ease-in-out
          ${isChecked ? currentSize.translate : "translate-x-0.5"}
        `}
      />
    </button>
  );
};
